import { OpportunitiesMenuItem } from 'domain/sales/opportunity';
import { useContactId, useContactUrl } from 'domain/sales/contact/contactRouting';
import { SidebarStickyMenu, SummaryMenuItem, NotesMenuItem } from 'framework/ui/menu';

const ContactsMenu = () => {
  const id = useContactId();
  const { getSingleEntityUrl, getRelatedOpportunitiesUrl, getNotesUrl } = useContactUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl(id)} exact />
      <OpportunitiesMenuItem linkUrl={getRelatedOpportunitiesUrl(id)} />
      <NotesMenuItem linkUrl={getNotesUrl(id)} />
    </SidebarStickyMenu>
  );
};

export default ContactsMenu;
